export class VitalParams {
    static readonly GDS = 'GDS';
    static readonly NEWS_TOT = 'news_tot';
    static readonly BR = 'br';
    static readonly O2 = 'o2';
    static readonly HR = 'hr';
    static readonly TP = 'tp';
    static readonly PH = 'ph';
    static readonly PL = 'pl';
    static readonly AC = 'ac';
    static readonly GA_SC = 'ga_sc'; // step count (per 20 sec window)
    static readonly GA_RV = 'ga_rv'; // HRV
    static readonly GA_ST = 'ga_st'; // step count total
    static readonly GA_ZE = 'ga_ze'; // zero crossing enrgy total
    static readonly GA_ZC = 'ga_zc'; // zero crossing (per 20 sec window)
    static readonly GA_SS = 'ga_ss'; // stress (per 20 sec window)
    static readonly BS = 'bs'; // Blood sugar
    static readonly W = 'w'; // weight
    static readonly H = 'h'; // height
    static readonly MP = 'mp';
    static readonly PP = 'pp';
    static readonly QT = 'QT';
    static readonly ESCO = 'esCO';
    static readonly STRESSIDX = 'StressIdx';
    static readonly SHOCKIDX = 'ShockIdx';
    static readonly CENTRIDX = 'CentrIdx';
    static readonly SDNN = 'SDNN';
    static readonly RMSSD = 'RMSSD';
    static readonly PNN50 = 'PNN50';
    static readonly BODY_POS = 'ac';
    static readonly DB = 'db';
    static readonly PB = 'pb';
}